//Take mixpanel's reference according to context
var mixpanelInstance = null;

// Queue to store events before Mixpanel is initialized
const eventQueue = [];

// Queued Mixpanel instance that stores events until initialization
// v3.x API: use getPeople() instead of people
const queuedMixpanel = {
  track: (event, properties) => {
    eventQueue.push({ type: 'track', args: [event, properties] });
  },
  register: properties => {
    eventQueue.push({ type: 'register', args: [properties] });
  },
  registerSuperProperties: properties => {
    eventQueue.push({ type: 'registerSuperProperties', args: [properties] });
  },
  identify: userId => {
    eventQueue.push({ type: 'identify', args: [userId] });
  },
  reset: () => {},
  getPeople: () => ({
    set: properties => {
      eventQueue.push({ type: 'people.set', args: [properties] });
    },
    union: (listName, values) => {
      eventQueue.push({ type: 'people.union', args: [listName, values] });
    },
  }),
};

// Replay all queued events to the real Mixpanel instance
const replayQueue = mixpanel => {
  let successCount = 0;
  let errorCount = 0;

  while (eventQueue.length > 0) {
    const event = eventQueue.shift();

    try {
      switch (event.type) {
        case 'track':
          mixpanel.track(...event.args);
          break;
        case 'register':
          mixpanel.register(...event.args);
          break;
        case 'registerSuperProperties':
          mixpanel.registerSuperProperties(...event.args);
          break;
        case 'identify':
          mixpanel.identify(...event.args);
          break;
        case 'people.set':
          // v3.x API: use getPeople().set()
          mixpanel.getPeople().set(...event.args);
          break;
        case 'people.union':
          // v3.x API: use getPeople().union()
          mixpanel.getPeople().union(...event.args);
          break;
      }
      successCount++;
    } catch (error) {
      console.error('Error replaying Mixpanel event:', event.type, error);
      errorCount++;
    }
  }
};

// Called by both Mobile (with mixpanel-react-native) and Web (with the
// browser SDK). The two SDKs differ on a couple of method names:
//   * Mobile exposes super-property registration as
//     `registerSuperProperties`; web uses `register`.
//   * Mobile exposes the user-profile object via `getPeople()`; web
//     exposes it as a `people` property.
// Normalize both onto the mobile-style names so callers (and the
// queue replay) can rely on `register` / `getPeople()` everywhere.
export var initMixpanel = mixpanel => {
  mixpanelInstance = mixpanel;
  if (typeof mixpanel.registerSuperProperties === 'function') {
    mixpanelInstance.register = mixpanel.registerSuperProperties;
  }
  if (
    typeof mixpanelInstance.getPeople !== 'function' &&
    mixpanelInstance.people
  ) {
    const peopleRef = mixpanelInstance.people;
    mixpanelInstance.getPeople = () => peopleRef;
  }

  // Replay all queued events
  replayQueue(mixpanelInstance);

  // Redirect queuedMixpanel to the real instance so that any code which
  // captured the queuedMixpanel reference in a closure before init still
  // forwards events correctly instead of pushing to the dead queue.
  queuedMixpanel.track = (event, properties) =>
    mixpanelInstance.track(event, properties);
  queuedMixpanel.register = properties => mixpanelInstance.register(properties);
  queuedMixpanel.registerSuperProperties = properties =>
    mixpanelInstance.registerSuperProperties(properties);
  queuedMixpanel.identify = userId => mixpanelInstance.identify(userId);
  queuedMixpanel.reset = () => mixpanelInstance.reset();
  const realPeople = mixpanelInstance.getPeople();
  queuedMixpanel.getPeople = () => realPeople;
};

export var getMixpanelInstance = () => {
  return mixpanelInstance || queuedMixpanel;
};
